import { render, staticRenderFns } from "./selfVideoPlayer.vue?vue&type=template&id=4cf8c043&scoped=true&"
import script from "./selfVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./selfVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./selfVideoPlayer.vue?vue&type=style&index=0&id=4cf8c043&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf8c043",
  null
  
)

export default component.exports